module.exports = __webpack_public_path__ + "static/img/lbt.089888c8.png";